import { Link } from "react-router-dom";
import styled from "styled-components";

// export const Container = styled("div")`
//   width: 340px;
//   position: absolute;
//   top: 46%;
//   right: 10%;
//   transform: translate(-50%, -50%);
//   @media (max-width: 1500px) {
//     right: 7%;
//   }
//   @media (max-width: 1350px) {
//     right: 3%;
//   }
//   @media (max-width: 1250px) {
//     right: 0%;
//   }
//   @media (max-width: 1250px) {
//     right: 0%;
//   }
// `;

export const SignContainer = styled("div")`
  width: 340px;
  position: absolute;
  top: 55%;
  right: 17%;
  transform: translate(-50%, -50%);
  @media (max-width: 1500px) {
    right: 7%;
  }
  @media (max-width: 1350px) {
    right: 3%;
  }
  @media (max-width: 1250px) {
    right: 0%;
  }
  @media (max-width: 1250px) {
    right: 0%;
  }
  @media (max-width: 960px) {
    margin-top: 500px;
    left: 30%;
  }
  @media (max-width: 660px) {
    margin-top: 600px;
    left: 40%;
  }
`;
export const LoginHeading = styled("div")`
  color: #B263DE;
  font-size: 31px;
  font-family:'Work Sans', sans-serif;
  font-weight:600;
  margin-bottom: 50px;
  @media (max-width: 768px) {
    margin-bottom: 20px;
    text-align: center;
  }
`;

export const SecondHeading = styled("div")`
  color: #a8a6a6;
  font-size: 13.97px;
  font-weight: 600;
`;

export const CustomLink = styled(Link)`
  color:#006bff;
  text-decoration:none;
  font-size:20.67px;
  font-weight: 400;
float:${(props) => (props.float ? props.float : "")};

`

export const CustomLinkSign = styled(Link)`
  color:#006bff;
  text-decoration:none;
  font-size:14.37px;
  font-weight: 600;
float:${(props) => (props.float ? props.float : "")};

`

export const CustomLinkForget = styled(Link)`
  color:#4678ED;
  text-decoration:none;
  font-size:14.17px;
  font-weight: 500;
  position: relative;
  top: 18px;
  left: 18px;
  float:${(props) => (props.float ? props.float : "")};

`

export const SPECCONTAINER = styled('div')`
  background-color: #efefef !important;
  position: absolute !important;
  padding-left: 300px;
  left: 0 !important;
  top: 0 !important;
  width: 50vw !important;
  height: 100vh !important;
  @media (max-width: 960px) {
    height: 70vh !important;
    width: 99vw !important;
  }
  @media (max-width: 660px) {
    height: 85vh !important;
    width: 99vw !important;
  }
`